import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addCurrency,
  DeleteCurrency,
  getCurrency,
  updateCurrency,
} from "store/services/dataManagement/currency";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Currency
export const GetAllCurrencyAction = createAsyncThunk(
  "currency/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getCurrency(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

//Delete Currency
export const DeleteCurrencyAction = createAsyncThunk(
  "currency/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, ...rest } = payload;
      const res = await DeleteCurrency(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) onSuccess();
        const responce = await getCurrency(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Update Currency
export const UpdateCurrencyAction = createAsyncThunk(
  "currency/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    let { onSucess, onError, ...rest } = payload;
    try {
      const res = await updateCurrency(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);

//Add Currency
export const AddCurrencyAction = createAsyncThunk(
  "currency/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSucess, onError, filter, ...rest } = payload;
      const res = await addCurrency(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSucess) onSucess();
        dispatch(closeAdminModal());

        const responce = await getCurrency(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
